<div class="setting-page">
  <legend>Users</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="!canSubmit">
    <arm-form-title>Users Values</arm-form-title>
    <div class="settings-section">
        <mat-checkbox [(ngModel)]="usersSettings.enabled"
                      [ngModelOptions]="{standalone: true}"
                      color="primary">
          Enable registered users feature
        </mat-checkbox>
    </div>
  </arm-form>
</div>
